import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Input } from "@/components/ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Skeleton } from "@/components/ui/skeleton";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AxiosRequestConfig } from "axios";
import { LEVEL_1, LEVEL_2, LEVEL_3 } from "common/constants";
import { checkLevel } from "common/rules";
import { useDebounce } from "pages/CreateDeal/newdeal";
import { ComboBoxCurrency } from "pages/PrepareQuoteConatct/L1Flow";
import { useEffect, useRef, useState } from "react";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import ReactSelect from "react-select";
import {
  getCountry,
  GetCountryRequestType,
  getPanCardDetails,
  GetPanCardDetailsRequestType,
  getPurpose,
  GetPurposeRequestType,
  getServicePartners,
  GetServicePartnersRequestType,
  PostDealCalcRequestType,
  postDealCalcWithMargin,
  shareQuoteAPI,
  ShareQuoteRequestType,
} from "service/apis/CreateDealapi";
import {
  getContactDetailsPrepareQuote,
  getGST,
  GetGSTRequestType,
  GetSearchConatctForPrepareQuoteRequestType,
  quoteFromHomePage,
  QuoteFromHomePageRequestType,
} from "service/apis/CreateForexQuotation";
import { toast } from "sonner";
import { formatIndianNumber, handleDownloadViaURL } from "utils";
import { ContactData } from "../dashboard-data";
import { X } from "lucide-react";
import ForexQuote, { forexProduct } from "./forexQuote";
import { Img, Spinner } from "components";
import { educationPaymentModes } from "./PrepareQuoteHomepageLevel2";

const purposeMapForEducation = [
  {
    label: "Via Transfer",
    value: "20",
    loan: false
  },
  {
    label: "Via Transfer",
    value: "19",
    loan: true
  },
  {
    label: "Western Union",
    value: "11",
    loan: false
  },
  {
    label: "Western Union",
    value: "10",
    loan: true
  },
  {
    label: "PayMyTuition",
    value: "18",
    loan: false,
  },
  {
    label: "PayMyTuition",
    value: "17",
    loan: true
  },
  {
    label: "Flywire",
    value: "9",
    loan: false
  },
  {
    label: "Flywire",
    value: "8",
    loan: true
  },
  {
    label: "CIBC",
    value: "16",
    loan: false
  },
   {
    label: "CIBC",
    value: "15",
    loan: true
  },
  {
    label: "GIC",
    value: "2",
    loan: false
  },
  {
    label: "GIC",
    value: "14",
    loan: true
  },
]

const tablist = [
  {
    label: "Remittance",
    value: "remit",
    enabled: true,
  },
  {
    label: "Forex",
    value: "forex",
    enabled: true,
  },
];

export default function PreparequoteHomepageLevel1() {
  const [activeTab, setActiveTab] = useState(tablist[0].value);
  const [countryoption, setCountryoption] = useState<
    { label: string; value: string }[]
  >([]);
  const [pancard, setPancard] = useState<string>("");
  const [panError, setPanError] = useState<string>("");
  const [pancardDetails, setPanCardDetails] = useState<any>(null);

  const [currencydata, setCurrencydata] = useState<
    { country: string; currency: string }[]
  >([]);
  const [purpose, setPurpose] = useState<{ label: string; value: string }[]>(
    []
  );
  const methods = useForm();
  const resetChildState = useRef<() => void>(() => {});
  const { setValue, watch, getValues, reset, register } = methods;
  const [isCalcLoading, setIsCalcLoading] = useState(false);
  const [showProfit, setShowProfit] = useState(false);

  const fetchCountry = () => {
    const payload: AxiosRequestConfig<GetCountryRequestType> = {};
    getCountry(payload)
      .then((res: any) => {
        setCurrencydata(res.data);
        setCountryoption(
          res.data.map((item: any) => {
            return {
              label: item.country,
              value: item.country,
            };
          })
        );
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };
  const fetchPurpose = () => {
    const payload: AxiosRequestConfig<GetPurposeRequestType> = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      params: {
        product_id: 0,
      },
    };
    getPurpose(payload)
      .then((res) => {
        const filteredPurpose = res.data.filter((item) => item.id !== 13);
        const newPurpose = filteredPurpose?.filter((item) =>
          ["1", "2", "3", "4"].includes(item.id.toString())
        );
        setPurpose(
          newPurpose?.map((item) => {
            return {
              label: item.name,
              value: item.id.toString(),
            };
          })
        );
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  // fetch Pancard
  const fetchPancard = async (pan_no: string) => {
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<GetPanCardDetailsRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      params: {
        pan_no: pan_no,
      },
    };
    try {
      const res: any = await getPanCardDetails(payload);
      if (res.status === 200) {
        setPanCardDetails(res?.data);
      }
    } catch (error) {
      console.error("PAN API error:", error);
    }
  };
  const handlePanChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.toUpperCase();

    // Allow only up to 10 characters
    if (value.length > 10) return;

    setPancard(value);
    setValue("pancard_no", value);

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (value.length === 10) {
      if (panRegex?.test(value)) {
        setPanError("");
        fetchPancard(value)
      } else {
        setPanError("Invalid PAN format (e.g. ABCDE1234F)");
        setPanCardDetails(null);
        setValue("pancard_no", "");
        setPancard("");
      }
    } else {
      setPanError("");
      setPanCardDetails(null);
      fetchCalc();
    }
  };

  useEffect(() => {
    if (!pancardDetails?.id || !pancard) {
      fetchCalc()
    }
    if (pancardDetails?.id) {
      fetchCalc();
    }
  }, [pancardDetails?.id]);

  const fetchServicePartners = (): void => {
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const payload: AxiosRequestConfig<GetServicePartnersRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      params: {
        purpose_id: watch("purpose"),
        currency: watch("currency"),
      },
    };

    getServicePartners(payload)
      .then((res) => {
        if (res.data.length > 0) {
          setValue("service_partner_id", res.data[0].id);
          fetchCalc();
        } else {
          setValue("service_partner_id", "");
        }

        if (res.data.length < 1) {
          toast.error("Service Partners not available");
        }
      })
      .catch((err) => {
        setValue("service_partner_id", "");
        toast.error(err.response.data.message);
      });
  };

  const fetchCalc = (): void => {
    if (!watch("amount") || !watch("service_partner_id")) return;
    if ((watch("purpose") === "1" || watch("purpose") === "2") && !watch('isLoanTaken')) {
      return;
    }
    setValue("cal_error", "");

    setIsCalcLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const channel = localStorage.getItem("channel_id");

    const payload: AxiosRequestConfig<PostDealCalcRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        purpose_id: (watch("purpose") === "1" || watch("purpose") === "2") ? watch("mode") : watch("purpose"),
        currency: watch("currency"),
        amount: watch("amount"),
        type: "beneficiary_receives",
        created_by: channel?.toString(),
        tcs_type: 1,
        discount: 0,
        customers_id: pancardDetails?.id,
        addon_rates: !watch("customer_rate")
          ? 0
          : Number(watch("customer_rate")) - watch("fixed_customer_rate"),
        country: watch("country"),
        service_partner_id: watch("service_partner_id"),
        partner_walkin_margin: "0",
        fx_charges: watch("fxCharges"),
        l1_commission: "0.5",
        l2_commission: "0",
        l3_commission: "0",
      },
    };

    postDealCalcWithMargin(payload)
      .then((res: any) => {
        setValue("tcs", res?.data.tcs);
        setValue("service_partner_id", res.data.service_partner);
        setValue("foreign_bank_charges", res.data.foreign_bank_charges);
        setValue("set_tt_charges", res.data.tt_charges);
        setValue("service_partner_mode", res.data.service_partner_mode);
        if (res.data.service_partner_mode === "online") {
          setValue("settlement_rates", res.data.settlement_rates);
        } else {
          setValue("settlement_rates", "");
        }
        setValue(
          "cal_total_charges",
          parseFloat(res.data.payable_amount) - parseFloat(res.data.base_amount)
        );
        if (checkLevel(LEVEL_1)) {
          setValue("cal_profit", Number(res.data.profit.l1).toFixed(4));
        }
        if (checkLevel(LEVEL_2)) {
          setValue("cal_profit", Number(res.data.profit.l2).toFixed(4));
        }
        if (checkLevel(LEVEL_3)) {
          setValue("cal_profit", Number(res.data.profit.l3).toFixed(4));
        }
        if (!watch("customer_rate")) {
          setValue(
            "customer_rate",
            Number(res.data.fixed_customer_rate)?.toFixed(4)
          );
        }
        // if (state?.partner_id) {
        //   setValue('partner_margin',res.data.commission.l1)
        // }
        setValue("cal_amount_inr", res.data.base_amount);
        setValue(
          "fixed_customer_rate",
          Number(res.data.fixed_customer_rate)?.toFixed(4)
        );
        setValue("cal_gst", res.data.gst);
        setValue("cal_tt_charges", res.data.tt_charges_with_gst);
        setValue("cal_total_payable", res.data.payable_amount);
        setValue(
          "cal_foreign_bank_charges",
          res.data.foreign_bank_charges_with_gst
        );
        setValue(
          "cal_your_rate",
          (
            parseFloat(res?.data?.settlement_rates) +
            (checkLevel(LEVEL_2) ? res?.data?.cumulative_commission.l1 : 0) +
            (checkLevel(LEVEL_3) ? res?.data?.cumulative_commission.l2 : 0)
          )?.toFixed(4)
        );
        setValue(
          "cal_customer_rate",
          parseFloat(res.data.customer_rate)?.toFixed(4)
        );
        setIsCalcLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setValue("cal_error", err.response.data.message);
        setIsCalcLoading(false);
      });
  };

  const buttonState = () => {
    if (activeTab === "remit") {
      if ((watch("purpose") === "1" || watch("purpose") === "2") && !watch("isLoanTaken")) {
        return true;
      }
      if (!watch("country")) {
        return true;
      }
      if (!watch("amount")) {
        return true;
      }
      if (watch("cal_error")) {
        return true;
      }
    }
    if (activeTab === "forex") {
      return !((watch("forex_products")?.length > 0))
    }
    return false;
  };

  useEffect(() => {
    reset({
      purpose: "",
      country: "",
      amount: "",
      fxCharges: "BEN",
      service_partner_id: "",
      cal_customer_rate: "",
      cal_profit: "",
      cal_total_charges: "",
      cal_gst: "",
      cal_tt_charges: "",
      cal_total_payable: "",
      cal_foreign_bank_charges: "",
      cal_amount_inr: "",
      cal_error: "",
      fx: "encashment",
      product: "",
      quantity: "",
      rate: "",
      service_charge: "",
      customer_rate: "",
      gst: false,
    });
  }, [activeTab]);

  const isInitialMount = useRef(true);

  // Clear customer_rate when dependencies change
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      if (watch("customer_rate")) {
        setValue("customer_rate", "");
      }
    }
  }, [
    watch("amount"),
    watch("country"),
    watch("mode"),
    watch("purpose"),
    setValue,
  ]);
  useDebounce(
    () => {
      const country = watch("country");
      const purpose = watch("purpose");
      const amount = watch("amount");
      const servicePartnerId = watch("service_partner_id");

      if (country && purpose) {
        fetchServicePartners();

        if (amount && servicePartnerId && !watch("customer_rate")) {
          fetchCalc();
        }
      }
    },
    600,
    [
      watch("amount"),
      watch("customer_rate"),
      watch("country"),
      watch("mode"),
      watch("purpose"),
      watch("service_partner_id"),
      watch("fxCharges"),
    ]
  );
  useEffect(() => {
    fetchCountry();
    fetchPurpose();
  }, []);
  return (
    <section className="w-full h-full flex flex-col gap-4">
      <Tabs
        className="flex sm:-mb-2 gap-2 w-full flex-col"
        value={activeTab}
        onValueChange={(value) => {
          setActiveTab(value);
        }}
      >
        <TabsList className=" p-0 w-full ">
          {tablist.map((tab) => (
            <TabsTrigger
              disabled={!tab.enabled}
              key={tab.value}
              value={tab.value}
              className={` py-[18px] px-6 border-b-2 rounded-none border-blue-700 disabled:opacity-40 text-base lg:text-lg h-[44px] w-full font-semibold ${tab.value === activeTab
                  ? "bg-navbar-menu-bg rounded-t-lg text-blue-700"
                  : " text-[#666666] font-medium"
                }`}
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent
          value="remit"
          className="w-full h-full flex flex-col gap-4"
        >
          <div className="w-full grid grid-cols-2 sm:grid-cols-1 gap-4">
            <div className="space-y-2 order-1 sm:col-span-2 ">
              <label
                htmlFor="purpose"
                className="text-sm font-normal leading-[17px] text-[#666666]"
              >
                Purpose
              </label>
              <ReactSelect
                className="w-full font-normal text-sm lg:text-base"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    zIndex: 0,
                    borderRadius: "0.5rem",
                    height: "3rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderColor: state.isFocused ? "#165FE3" : "#d2d2d2",
                    boxShadow: "none",
                  }),
                }}
                isMulti={false}
                name="purpose"
                isSearchable={false}
                options={purpose}
                value={
                  watch("purpose")
                    ? purpose.find((item) => item.value === watch("purpose"))
                    : null
                }
                id="purpose"
                onChange={(e) => {
                  if (e?.value !== "1") {
                    setValue("mode", "");
                  }
                  setValue("purpose", e?.value || "");
                }}
                placeholder="Select Purpose"
              />
            </div>
            <div className="space-y-2 order-2 sm:col-span-2">
              <label
                htmlFor="country"
                className="text-sm font-normal leading-[17px] text-[#666666]"
              >
                Country
              </label>
              <ReactSelect
                className="w-full font-normal text-sm lg:text-base"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    zIndex: 0,
                    borderRadius: "0.5rem",
                    height: "3rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderColor: state.isFocused ? "#165FE3" : "#d2d2d2",
                    boxShadow: "none",
                  }),
                }}
                isMulti={false}
                options={countryoption}
                name="country"
                id="country"
                value={
                  watch("country")
                    ? countryoption.find(
                      (item) => item.value === watch("country")
                    )
                    : null
                }
                onChange={(e) => {
                  const selectedCountry = e?.value;
                  setValue("country", selectedCountry || "");
                  const selectedCurrency = currencydata.find(
                    (item: any) => item.country === selectedCountry
                  )?.currency;
                  if (selectedCurrency) {
                    setValue("currency", selectedCurrency || "");
                  }
                }}
                placeholder="Select Country"
              />
            </div>
            <div className="relative sm:col-span-2 space-y-2 order-3">
              <label
                htmlFor="amount"
                className="text-sm font-normal leading-[17px] text-[#666666]"
              >
                Currency & Amount
              </label>
              <div className="relative w-full rounded-md">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2.5">
                  <span className=" font-normal leading-4 -tracking-[1%] p-2.5 rounded-md bg-[#E1EBFC] text-blue-700 sm:text-sm">
                    {watch("currency") ? watch("currency") : "INR"}
                  </span>
                </div>
                <Input
                  type="number"
                  onWheel={(e) => e.currentTarget.blur()}
                  id="amount"
                  {...register("amount")}
                  value={watch("amount")}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "") {
                      setValue("cal_customer_rate", "");
                    }
                    setValue("amount", value);
                  }}
                  name="amount"
                  placeholder="Enter amount"
                  className="m-0 h-12 max-w-[340px] pl-[70px] border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg font-normal text-sm lg:text-base"
                />
              </div>
            </div>
            {
              (watch("purpose") === "1" || watch("purpose") === "2") &&
              <div className="space-y-2 order-4 sm:col-span-2">
                <label
                  htmlFor="fxCharges"
                  className="text-sm font-medium leading-[17px] text-[#666666]"
                >
                  Have you taken loan?
                </label>
                <RadioGroup
                  className="flex"
                  onValueChange={(value: "YES" | "NO") => {
                    setValue('isLoanTaken', value);
                    if(watch('mode') || watch('purpose') === '2') {   
                      const purposeOrMode = watch('purpose') === '2' ? watch('purpose') : watch('mode')                   
                      const getPurpose = purposeMapForEducation?.find(item=>item.value === purposeOrMode)?.label
                      if(getPurpose) {
                        const newMode = purposeMapForEducation?.find(item=>item.label === getPurpose && item.loan === (value === "YES"))
                        if(newMode) {
                          setValue("mode", newMode.value)
                        }
                      }
                    }
                  }}
                  value={watch("isLoanTaken")}
                  aria-label="isLoanTaken"
                  name="isLoanTaken"
                  id="isLoanTaken"
                >
                  <label
                    htmlFor="YES"
                    className={` ${watch("isLoanTaken") === "YES" ? " border-blue-700" : " "
                      } flex items-center rounded-lg border p-3 h-12 space-x-2 w-full`}
                  >
                    <RadioGroupItem
                      value="YES"
                      id="YES"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
                    />
                    <p>Yes</p>
                  </label>
                  <label
                    htmlFor="NO"
                    className={` ${watch("isLoanTaken") === "NO" ? "border-blue-700" : ""
                      } flex items-center rounded-lg border p-3 h-12 space-x-2 w-full`}
                  >
                    <RadioGroupItem
                      value="NO"
                      id="NO"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
                    />
                    <p>No</p>
                  </label>
                </RadioGroup>
              </div>
            }
            <div className="space-y-2 order-4 sm:col-span-2">
              <label
                htmlFor="fxCharges"
                className="text-sm font-normal leading-[17px] text-[#666666]"
              >
                FX Charges
              </label>
              <RadioGroup
                className="flex font-normal text-sm lg:text-base"
                onValueChange={(value: "BEN" | "OUR") => {
                  setValue("fxCharges", value);
                }}
                value={watch("fxCharges")}
                aria-label="fxCharges"
                name="fxCharges"
                id="fxCharges"
              >
                <label
                  htmlFor="BEN"
                  className={` ${watch("fxCharges") === "BEN" ? " border-blue-700" : " "
                    } flex items-center rounded-lg border p-3 h-12 space-x-2 w-full`}
                >
                  <RadioGroupItem
                    value="BEN"
                    id="BEN"
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
                  />
                  <p>BEN</p>
                </label>
                <label
                  htmlFor="OUR"
                  className={` ${watch("fxCharges") === "OUR" ? "border-blue-700" : ""
                    } flex items-center rounded-lg border p-3 h-12 space-x-2 w-full`}
                >
                  <RadioGroupItem
                    value="OUR"
                    id="OUR"
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
                  />
                  <p>OUR</p>
                </label>
              </RadioGroup>
            </div>
            <div className="relative space-y-2 order-6 sm:col-span-2">
              <label
                htmlFor="customer_rate"
                className="text-sm font-normal leading-[17px] text-[#666666]"
              >
                Enter the customer rate
              </label>
              <div className="relative w-full rounded-md">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2.5">
                  <span className="font-normal leading-4 -tracking-[1%] p-2.5 rounded-md bg-[#E1EBFC] text-blue-700 sm:text-sm">
                    INR
                  </span>
                </div>
                <Input
                  type="number"
                  onWheel={(e) => e.currentTarget.blur()}
                  id="customer_rate"
                  name="customer_rate"
                  placeholder="customer rate"
                  value={watch("customer_rate")}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValue("customer_rate", value);
                  }}
                  className="m-0 h-12 max-w-[340px] pl-[70px] border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
                />
              </div>
            </div>
            <div className="space-y-2 order-6 sm:col-span-2">
              <label
                htmlFor="pancard_no"
                className="text-sm font-normal leading-[17px] text-[#666666]"
              >
                Enter Pancard {'(optional)'}
              </label>
              <div className="relative w-full rounded-md">
                <Input
                  type="text"
                  id="pancard_no"
                  name="pancard_no"
                  placeholder="Pancard Number"
                  value={pancard}
                  onChange={handlePanChange}
                  className="font-normal text-sm lg:text-base m-0 h-12 max-w-[340px] border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg uppercase"
                />
                {panError && (
                  <p className="text-red-500 text-xs mt-1">{panError}</p>
                )}
              </div>
            </div>
            {watch("purpose") === "1" && (
              <div className="space-y-2 col-span-2 order-2">
                <label
                  htmlFor="mode"
                  className="text-sm font-normal leading-[17px] text-[#666666]"
                >
                  Mode
                </label>
                <RadioGroup
                  className="w-full grid grid-cols-3 sm:grid-cols-2"
                  onValueChange={(value) => {
                    if(watch('isLoanTaken') === "YES") {
                      const getPurpose = purposeMapForEducation?.find(item=>item.value === value)?.label
                      if(getPurpose) {
                        const newMode = purposeMapForEducation?.find(item=>item.label === getPurpose && item.loan === true)
                        if(newMode) {
                          setValue("mode", newMode.value)
                        }
                      }
                      return
                    }
                    if(watch('isLoanTaken') === "NO") {
                      const getPurpose = purposeMapForEducation?.find(item=>item.value === value)?.label
                      if(getPurpose) {
                        const newMode = purposeMapForEducation?.find(item=>item.label === getPurpose && item.loan === false)
                        if(newMode) {
                          setValue("mode", newMode.value)
                        }
                      }
                      return
                    }
                    setValue("mode", value);
                  }}
                  value={purposeMapForEducation?.find(item=> item.label === educationPaymentModes?.find(item=>item.value === watch("mode"))?.label && item.loan === false)?.value}
                  aria-label="mode"
                  name="mode"
                  id="mode"
                >
                  {educationPaymentModes.map((item) => (
                    <label
                      key={item.value}
                      htmlFor={item.label}
                      className={` ${purposeMapForEducation?.find(item=>item.value === watch("mode"))?.label === item.label ? " border-blue-700" : " "
                        } flex items-center w-full rounded-lg border p-3 h-12 space-x-2`}
                    >
                      <RadioGroupItem
                        value={item.value}
                        id={item.label}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
                      />
                      <p>{item.label}</p>
                    </label>
                  ))}
                </RadioGroup>
              </div>
            )}
          </div>
          {watch("amount") && watch("country") && !watch("cal_error") && (
            <section className="flex-1 bg-white-A700 py-5 rounded-xl gap-4 flex flex-col">
              <div className="lg:pt-5 pb-10 lg:px-5 border-b-8 rounded-xl bg-custom-calc-gradient border-blue-700 gap-10">
                <div className="divide-y divide-neutral-400_1 gap-5 flex flex-col">
                  <div className="flex flex-col gap-4 w-full">
                    <div className="flex justify-between w-full">
                      <span className="text-sm font-normal leading-[14.5px] indent-3.5 text-[#666666]">
                        Customer Rate
                      </span>
                      {isCalcLoading ? (
                        <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                      ) : (
                        <span className="text-sm font-semibold float-right leading-4 indent-3.5 text-[#333333]">
                          {!watch("cal_customer_rate")
                            ? "0.00"
                            : `₹ ${watch("cal_customer_rate")}`}
                        </span>
                      )}
                    </div>
                    <div className="flex justify-between w-full">
                      <span className="text-sm font-normal leading-[14.5px] indent-3.5 text-[#666666]">
                        Recipient gets
                      </span>
                      {isCalcLoading ? (
                        <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                      ) : (
                        <span className="text-sm font-semibold float-right leading-4 indent-3.5 text-[#333333]">
                          {!watch("amount")
                            ? "0.00"
                            : (!watch("currency") || !watch("currency")
                              ? "USD "
                              : `${watch("currency")} `) +
                            formatIndianNumber(
                              parseFloat(watch("amount"))?.toFixed(4)
                            ).toString()}
                        </span>
                      )}
                    </div>
                    <div className="w-full border-[.3px]" />
                    <div className="flex flex-col w-full gap-4">
                      <div className="flex justify-between w-full">
                        <span className="text-sm leading-[17px] indent-3.5 font-normal">
                          Total Charges
                        </span>
                        {isCalcLoading ? (
                          <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                        ) : (
                          <span className="text-sm font-semibold float-right leading-4 indent-3.5 text-[#333333]">
                            {!watch("cal_total_charges") || !watch("amount")
                              ? "0.00"
                              : `INR ${parseFloat(
                                Number(watch("cal_total_charges"))?.toFixed(2)
                              )}`}
                          </span>
                        )}
                      </div>
                      <div className="ml-4 border-l border-gray-300 flex flex-col gap-4 mt-2">
                        <div className="flex justify-between w-full mb-2">
                          <span className="text-sm font-medium leading-[14.5px] indent-3.5 text-[#666666]">
                            GST on FX conversion
                          </span>
                          {isCalcLoading ? (
                            <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                          ) : (
                            <span className="text-sm float-right leading-4 indent-3.5 text-[#333333]">
                              {!watch("cal_gst") || !watch("amount")
                                ? "0.00"
                                : `INR ${Number(watch("cal_gst"))?.toFixed(2)}`}
                            </span>
                          )}
                        </div>
                        <div className="flex justify-between w-full mb-2">
                          <span className="text-sm font-medium leading-[14.5px] indent-3.5 text-[#666666]">
                            TCS
                          </span>
                          {isCalcLoading ? (
                            <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                          ) : (
                            <span className="text-sm float-right leading-4 indent-3.5 text-[#333333]">
                              {!watch("tcs")
                                ? "0.00"
                                : `INR ${Number(watch("tcs"))?.toFixed(2)}`}
                            </span>
                          )}
                        </div>
                        <div className="flex justify-between w-full mb-2">
                          <span className="text-sm font-medium leading-[14.5px] indent-3.5 text-[#666666]">
                            Foreign Bank charges{" "}
                            <span className="text-sm font-medium text-gray-500">
                              (incl. GST)
                            </span>
                          </span>
                          {isCalcLoading ? (
                            <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                          ) : (
                            <span className="text-sm float-right leading-4 indent-3.5 text-[#333333]">
                              {!watch("cal_foreign_bank_charges") ||
                                !watch("amount")
                                ? "0.00"
                                : `INR ${Number(
                                  watch("cal_foreign_bank_charges")
                                )?.toFixed(2)}`}
                            </span>
                          )}
                        </div>
                        <div className="flex justify-between w-full">
                          <span className="text-sm font-medium leading-[14.5px] indent-3.5 text-[#666666]">
                            TT charges{" "}
                            <span className="text-sm font-medium text-gray-500">
                              (incl. GST)
                            </span>
                          </span>
                          {isCalcLoading ? (
                            <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                          ) : (
                            <span className="text-sm float-right leading-4 indent-3.5 text-[#333333]">
                              {!watch("cal_tt_charges") || !watch("amount")
                                ? "0.00"
                                : `INR ${Number(
                                  watch("cal_tt_charges")
                                )?.toFixed(2)}`}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between pt-2.5 text-blue-700 w-full">
                    <span className="text-md leading-[14.5px] indent-3.5 font-semibold">
                      Total estimation
                    </span>
                    {isCalcLoading ? (
                      <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                    ) : (
                      <span className=" font-medium float-right leading-4 indent-3.5 ">
                        {!watch("cal_total_payable") || !watch("amount")
                          ? "0.00"
                          : `INR ${formatIndianNumber(
                            parseFloat(watch("cal_total_payable"))?.toFixed(2)
                          )}`}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
          <div className="w-full">
            <div className="w-full rounded-md flex items-center">
              <div className="flex items-center justify-between w-full bg-[#F9F9F9] rounded-xl border-none py-0 pr-5  ">               
                <small className="font-base leading-4 -tracking-[1%] p-2.5 rounded-md text-[#666666] text-sm">
                  <Img src="/images/profit.png" alt="info" className=" w-5 h-5" />
                </small>
                <div className="flex items-center gap-1.5">
                  {
                    showProfit ? (
                      <small className="font-base leading-4 -tracking-[1%] rounded-md text-[#666666] text-sm">
                        INR{" "}
                        {watch("cal_profit") ? watch("cal_profit") : "0.00"}
                      </small>
                    ) : (
                      <span className="text-sm font-semibold leading-4 text-blue-700">
                        Click to view profit
                      </span>
                    )
                  }
                  <button onClick={() => setShowProfit(!showProfit)}>
                    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 5C11.7956 5 12.5587 5.31607 13.1213 5.87868C13.6839 6.44129 14 7.20435 14 8C14 8.79565 13.6839 9.55871 13.1213 10.1213C12.5587 10.6839 11.7956 11 11 11C10.2044 11 9.44129 10.6839 8.87868 10.1213C8.31607 9.55871 8 8.79565 8 8C8 7.20435 8.31607 6.44129 8.87868 5.87868C9.44129 5.31607 10.2044 5 11 5ZM11 0.5C16 0.5 20.27 3.61 22 8C20.27 12.39 16 15.5 11 15.5C6 15.5 1.73 12.39 0 8C1.73 3.61 6 0.5 11 0.5ZM2.18 8C2.98825 9.65031 4.24331 11.0407 5.80248 12.0133C7.36165 12.9858 9.1624 13.5013 11 13.5013C12.8376 13.5013 14.6383 12.9858 16.1975 12.0133C17.7567 11.0407 19.0117 9.65031 19.82 8C19.0117 6.34969 17.7567 4.95925 16.1975 3.98675C14.6383 3.01424 12.8376 2.49868 11 2.49868C9.1624 2.49868 7.36165 3.01424 5.80248 3.98675C4.24331 4.95925 2.98825 6.34969 2.18 8Z" fill="#165FE3" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </TabsContent>
        <TabsContent
          value="forex"
          className="w-full h-full flex flex-col gap-4"
        >
          <FormProvider {...methods}>
            <ForexQuote reset={fn=>(resetChildState.current = fn)} />
          </FormProvider>
        </TabsContent>
      </Tabs>
      <FormProvider {...methods}>
        <ContactAlert handleSubmit={resetChildState?.current!}>
          <button
            disabled={buttonState()}
            className="bg-blue-700 py-4 disabled:opacity-40 disabled:cursor-not-allowed text-white-A700 font-semibold text-sm leading-5 rounded-lg w-full hover:bg-blue-800 transition duration-200 ease-in-out"
          >
            Get Quote
          </button>
        </ContactAlert>
      </FormProvider>
    </section>
  );
}

interface AlertProps {
  children: React.ReactNode;
  handleSubmit?: () => void;
}

const ContactAlert = ({ children , handleSubmit:resetStates}: AlertProps) => {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    []
  );
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState<string | null>(null);
  // const [selectedNumber, setSelectedNumber] = useState<string | null>(null);
  const [isSelectedNumber, setISSelectedNumber] = useState(false);
  const [contactDetails, setContactDetails] = useState<any>(null);
  const [selectedContact, setSelectedContatcted] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [buttonType, setButtonType] = useState("download");

  const { watch, getValues, setValue, reset } = useFormContext();

  const fetchSearchResults = async () => {
    if (!inputValue) {
      return;
    }
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<GetSearchConatctForPrepareQuoteRequestType> =
    {
      headers: { Authorization: `Bearer ${authToken}` },
      params: {
        phone_number: inputValue,
      },
    };
    try {
      if (inputValue === "") return;
      const response = (await getContactDetailsPrepareQuote(payload)) as any;
      if (response?.data?.length === 0) {
        setOptions(() => []);
        setShowDropdown(true);
        setSelectedNumber(null);
        return;
      }
      let newOptions: ContactData[];
      newOptions = response?.data?.map((item: any) => ({
          value: item?.id,
          label: item?.full_name,
          contactName: item?.full_name,
          contactPhone: item?.phone_number,
          email: item?.email,
          location: item?.contactAddress?.[1] || null,
          type: item?.contactPersonType || null,
          contactType: item?.contactPersonType || null,
      }));

      const startingWithInput = newOptions.filter((item) =>
        item.contactPhone.startsWith(inputValue)
      );
      const containingInput = newOptions.filter(
        (item) =>
          !item.contactPhone.startsWith(inputValue) &&
          item.contactPhone.includes(inputValue)
      );

      // Prioritize numbers that start with inputValue
      const sortedOptions = [...startingWithInput, ...containingInput];

      setShowDropdown(true);
      setOptions(sortedOptions as any);
    } catch (error: any) {
      if (error.response?.status === 429) {
        toast.error("Search limit exceeded.", {
          description:
            "You have exceeded the limit of requests. Please try again later.",
        });
      }
      toast.error("Error fetching options");
      setOptions([]);
      setShowDropdown(false);
      setSelectedNumber(null);
      setISSelectedNumber(false);
    }
  };

  const handleSubmit = async (
    type: string
  ): Promise<string | undefined | void> => {
    try {
      // Retrieve and validate the auth token
      const auth = localStorage.getItem("authToken");
      if (!auth) {
        console.error("No auth token found");
        return;
      }

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(
        2,
        "0"
      )}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(
        today.getFullYear()
      ).slice(-2)}`;

      const remit_qoute_data = {
        data: {
          date: formattedDate,
          customer_name: selectedContact?.contactName,
          customer_number: selectedContact?.contactPhone,
          purpose: (watch("purpose") === "1" || watch("purpose") === "2")? watch("mode") : watch("purpose"),
          currency: watch("currency"),
          remitter_send: `₹ ${formatIndianNumber(
            parseFloat(watch("cal_total_payable"))?.toFixed(2)
          )}`,
          beneficiary_received: `${watch("currency") || "USD"
            } ${formatIndianNumber(parseFloat(watch("amount"))?.toFixed(4))}`,
          customer_rate: watch("cal_customer_rate")
            ? `₹ ${watch("cal_customer_rate")}`
            : "₹ 0.00",
          total_charges: `₹ ${Number(watch("cal_total_charges"))?.toFixed(2)}`,
          gst: `₹ ${Number(watch("cal_gst"))?.toFixed(2)}`,
          fb_charges: `₹ ${Number(watch("cal_foreign_bank_charges"))?.toFixed(
            2
          )}`,
          tt_charges: `₹ ${Number(watch("cal_tt_charges"))?.toFixed(2)}`,
          payable_amount: `₹${formatIndianNumber(
            parseFloat(watch("cal_total_payable"))?.toFixed(2)
          )}`,
          partner_name: "",
        },
      };

      const todayDate = new Date();
      // Calculate the date after 7 days
      today.setDate(today.getDate());

      const laterDate = new Date(todayDate);
      laterDate.setDate(today.getDate() + 2);

      // Format the date in "dd/mm/yy" format
      const day = String(today.getDate()).padStart(2, "0");
      const laterDay = String(laterDate.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const laterMonth = String(laterDate.getMonth() + 1).padStart(2, "0");
      const year = String(today.getFullYear()).slice(-2);
      const laterYear = String(laterDate.getFullYear()).slice(-2);

      const formattedDateForex = `${day}-${month}-${year}`;
      const endDate = `${laterDay}-${laterMonth}-${laterYear}`;

      const forexProducts = getValues("forex_products") || [];
      const isForex = forexProducts?.[0]?.product;
      const overallServiceCharge = getValues("overall_service_charge") || "0";
      const gstIncluded = getValues("gst_included") || false;
      const fx_type = watch("fx");

      // Calculate product totals (without service charges)
      const productTotals = forexProducts?.reduce(
        (acc, product) => ({
          sub_total: acc.sub_total + product.amount,
          gst_total: acc.gst_total + product.gst_on_fx,
          product_payable_total: acc.product_payable_total + product.total_payable,
        }),
        { sub_total: 0, gst_total: 0, product_payable_total: 0 }
      );

      // Calculate overall service charges
      let service_charges_total = 0;
      let service_charge_gst = 0;
      const service_charge = parseFloat(overallServiceCharge) || 0;
      const gst_total = watch('cal_gst') || 0;
      const grand_total = watch('cal_total_payable') || 0

      if (service_charge > 0) {
        if (gstIncluded) {
          // GST is included in the service charge
          service_charges_total = service_charge;
          service_charge_gst = (service_charge / 1.18) * 0.18;
        } else {
          // GST needs to be added to service charge
          service_charge_gst = (service_charge * 18) / 100;
          service_charges_total = service_charge + service_charge_gst;
        }
      }

       const updatedProducts = forexProducts?.map((product: any) => {
         const currency_have =
           product?.forex_Type !== "encashment"
             ? "INR"
             : product?.currency || "";
         const currency_want =
           product?.forex_Type !== "encashment"
             ? product?.currency || ""
             : "INR";

         return {
           product_name:
             forexProduct.find((item) => item?.value === product?.product)
               ?.label || "",
           product_qty: `${product?.currency} ${formatIndianNumber(
             product?.quantity
           )}`,
           product_rate: parseFloat(product?.rate) || 0,
           product_gst: product?.gst_on_fx,
           product_service_charge: 0,
           product_total: formatIndianNumber(product?.amount?.toFixed(4)),
           currency_have,
           currency_want,
           inr_amount: Number(product?.total_payable),
           quantity: Number(product?.quantity),
           product_id: Number(product?.product),
         };
       });


      const forex_quote_data = {
        data: {
          product_type: watch("fx"),
          customer_name: selectedContact?.contactName,
          customer_email: selectedContact?.email,
          customer_passport: selectedContact?.passport,
          customer_phone_number: selectedContact?.contactPhone,
          sub_total: formatIndianNumber(productTotals.sub_total.toFixed(2)),
          gst_total: formatIndianNumber(parseFloat(gst_total)?.toFixed(2)),
          service_charges_total: formatIndianNumber(service_charges_total.toFixed(2)),
          grand_total: formatIndianNumber(parseFloat(grand_total)?.toFixed(2)),
          commission: formatIndianNumber((parseFloat(grand_total) * 0.02).toFixed(2)),
          commission_date: endDate,
          products: updatedProducts,
          date: formattedDateForex,
          name: "",
          total: Math.round(Number(grand_total)),
          service_charges: overallServiceCharge,
          gst: gst_total,
          subTotal: productTotals.sub_total,
          // Additional fields for the new structure
          overall_service_charge: overallServiceCharge,
          gst_included: gstIncluded,
          service_charge_gst: service_charge_gst,
        },
      };

      const authToken = JSON.parse(auth);

      const channelArray = [];
      if (watch("share_whatsapp")) {
        channelArray.push("whatsapp");
      }
      if (watch("share_email")) {
        channelArray.push("email");
      }

      // Prepare the payload
      const payload: AxiosRequestConfig<QuoteFromHomePageRequestType> = {
        headers: { Authorization: `Bearer ${authToken}` },
        data: {
          data: isForex
            ? forex_quote_data.data
            : remit_qoute_data.data,
          contacts_id: selectedContact?.value,
          Name: getValues("name"),
          email: getValues("email"),
          number: inputValue,
          pancard: "",
          purpose_id: isForex ? null : getValues("purpose"),
          channel: channelArray,
          country: getValues("country"),
          product_id: isForex ? isForex : null,
          amount: productTotals?.sub_total?.toString() || '',
        },
      };
      // Set loading state and make the API call
      setLoading(true);
      const res = (await quoteFromHomePage(payload)) as any;
      if (res?.status === 200) {
        setLoading(false);
        setOpen(false);
        setInputValue("");
        setOptions([]);
        setShowDropdown(false);
        setSelectedNumber(null);
        setContactDetails(null);
        setISSelectedNumber(false);
        reset({
          purpose: "",
          country: "",
          fxCharges: "BEN",
          amount: "",
          customer_rate: "",
          service_partner_id: "",
          cal_customer_rate: "",
          cal_profit: "",
          cal_total_charges: "",
          cal_gst: "",
          cal_tt_charges: "",
          cal_total_payable: "",
          cal_foreign_bank_charges: "",
          cal_amount_inr: "",
          cal_error: "",
          fx: "encashment",
          product: "",
          quantity: "",
          rate: "",
          service_charge: "",
          gst: false,          
        });
        resetStates?.()
        if (type === "download") {
          handleDownloadViaURL(res?.data);
          toast.success("Quote downloaded successfully");
        } else {
          toast.success("Quote shared successfully");
          setButtonType("download");
        }
      }
      // Handle the response
    } catch (err: any) {
      toast.error(err.message || "An error occurred");
      setLoading(false);
    } finally {
      setLoading(false); // Ensure loading is always turned off
    }
  };

  const handleSelectList = (
    option: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setValue("email", option?.email);
    setValue("name", option?.contactName);
    setInputValue(option.contactPhone?.replace("+", ""));
    setSelectedNumber(option.contactPhone);
    setContactDetails(option);
    setShowDropdown(false);
    setSelectedContatcted(option);
    setISSelectedNumber(true);
  };

  useDebounce(
    () => {
      if (inputValue.length >= 10) {
        fetchSearchResults();
      } else {
        setOptions([]);
        setShowDropdown(false);
        setSelectedNumber(null);
        setISSelectedNumber(false);
      }
    },
    600,
    [inputValue]
  );

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger>{children}</AlertDialogTrigger>
      <AlertDialogPortal>
        {loading && <Spinner />}
        <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
        <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-md animate-contentShow gap-0">
          <AlertDialogHeader className="flex flex-row items-center justify-between text-left gap-4 pt-4 pb-4 px-10 border-b">
            <AlertDialogTitle className="font-bold text-xl leading-7 tracking-[2%] text-gray-900">
              {buttonType === "download" ? "Contact details" : "Share Quote"}
            </AlertDialogTitle>
            <X
              onClick={() => {
                if (buttonType === "share") {
                  setButtonType("download");
                  return;
                }
                setOpen(false);
                setInputValue("");
                setOptions([]);
                setShowDropdown(false);
                setSelectedNumber(null);
                setISSelectedNumber(false);
                setContactDetails(null);
                setValue("email", "");
                setValue("name", "");
                setValue("share_whatsapp", false);
                setValue("share_email", false);
              }}
              className="cursor-pointer !m-0"
              size={20}
              color="#165fe3"
            />
          </AlertDialogHeader>
          <form action="" className="px-10 py-[30px] space-y-4">
            {buttonType === "download" ? (
              <>
                <div className="space-y-2">
                  <label
                    htmlFor="amount"
                    className="text-sm font-medium leading-[17px] text-[#666666]"
                  >
                    Mobile number
                  </label>
                  <div className="relative w-full h-12 flex rounded-md">
                    <ComboBoxCurrency />
                    <Input
                      type="number"
                      onWheel={(e) => e.currentTarget.blur()}
                      placeholder="Enter the mobile number"
                      onChange={(e) => {
                        const value = e.target.value;
                        setInputValue(value);
                        if (value.trim() === "") {
                          setOptions([]);
                          setShowDropdown(false);
                          setSelectedNumber(null);
                          setISSelectedNumber(false);
                          setValue("email", "");
                          setValue("name", "");
                          setContactDetails(null);
                        }
                      }}
                      value={inputValue}
                      className="text-sm font-medium border border-black-label h-12 rounded-lg rounded-tl-none border-l-0 rounded-bl-none p-4 w-full"
                    />
                  </div>
                </div>
                {showDropdown && options?.length > 0 && (
                  <div
                    className={`${showDropdown ? "block border" : "hidden"
                      } relative w-full bg-white  border-gray-300 rounded-md mt-1 shadow-lg max-h-48 overflow-y-auto`}
                  >
                    {options?.length > 0
                      ? options.map((option: any) => (
                        <button
                          key={option.value}
                          className="flex w-full justify-between items-center p-3 text-sm font-medium cursor-pointer hover:bg-gray-100"
                          onClick={(event) => handleSelectList(option, event)}
                        >
                          <span className="text-gray-600">
                            {option.contactPhone}
                          </span>
                          <span className="font-medium">
                            {option.contactName}
                          </span>
                        </button>
                      ))
                      : null}
                  </div>
                )}
              </>
            ) : (
              <div className="">
                <p className="">Share</p>
                <div className="bg-[#FAFAFA] flex gap-2 flex-col p-2 rounded-lg">
                  <label className="flex items-center gap-2" htmlFor="whatsapp">
                    <input
                      checked={watch("share_whatsapp")}
                      onChange={(e) => {
                        setValue("share_whatsapp", e.target.checked);
                      }}
                      type="checkbox"
                      name="whatsapp"
                      id="whatsapp"
                      className="rounded-[4px]"
                    />
                    <p className="flex justify-between w-full items-center">
                      Whatsapp
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_8576_141444)">
                          <path
                            d="M0.345625 7.90159C0.34525 9.2459 0.69925 10.5585 1.37238 11.7155L0.28125 15.6685L4.35825 14.6078C5.4859 15.2169 6.74934 15.536 8.03325 15.5361H8.03663C12.2751 15.5361 15.7253 12.1139 15.7271 7.90761C15.7279 5.86934 14.9286 3.95269 13.4765 2.51071C12.0246 1.06885 10.0937 0.274368 8.03631 0.273438C3.79738 0.273438 0.347438 3.69545 0.345688 7.90159"
                            fill="url(#paint0_linear_8576_141444)"
                          />
                          <path
                            d="M0.066875 7.90177C0.0664375 9.29445 0.433125 10.654 1.13025 11.8524L0 15.9471L4.22319 14.8484C5.38681 15.4779 6.69694 15.8098 8.03006 15.8103H8.0335C12.424 15.8103 15.9981 12.265 16 7.90809C16.0007 5.79659 15.1727 3.81104 13.6687 2.3174C12.1646 0.823938 10.1646 0.000868217 8.0335 0C3.64225 0 0.068625 3.54481 0.066875 7.90177ZM2.58194 11.646L2.42425 11.3976C1.76137 10.3518 1.4115 9.14326 1.412 7.90226C1.41337 4.28087 4.38363 1.33457 8.036 1.33457C9.80475 1.33532 11.467 2.01947 12.7172 3.26078C13.9674 4.5022 14.6554 6.15243 14.6549 7.9076C14.6533 11.529 11.683 14.4757 8.0335 14.4757H8.03088C6.84256 14.475 5.67712 14.1584 4.66075 13.56L4.41888 13.4177L1.91275 14.0696L2.58194 11.646Z"
                            fill="url(#paint1_linear_8576_141444)"
                          />
                          <path
                            d="M6.04125 4.59977C5.89212 4.27091 5.73519 4.26427 5.59337 4.2585C5.47725 4.25354 5.3445 4.25391 5.21187 4.25391C5.07912 4.25391 4.86344 4.30346 4.68112 4.50098C4.49862 4.69869 3.98438 5.17646 3.98438 6.14818C3.98438 7.1199 4.69769 8.05906 4.79712 8.19097C4.89669 8.32263 6.17419 10.3805 8.19744 11.1722C9.87894 11.8302 10.2211 11.6993 10.5861 11.6663C10.9511 11.6334 11.7638 11.1887 11.9296 10.7275C12.0956 10.2663 12.0956 9.87103 12.0458 9.78842C11.9961 9.70613 11.8633 9.6567 11.6642 9.55797C11.4652 9.45925 10.4865 8.98135 10.3041 8.91543C10.1216 8.84957 9.98887 8.8167 9.85612 9.01447C9.72337 9.21193 9.34219 9.6567 9.226 9.78842C9.10994 9.92045 8.99375 9.93689 8.79475 9.8381C8.59556 9.739 7.9545 9.53069 7.19394 8.85788C6.60219 8.33435 6.20269 7.68783 6.08656 7.49007C5.97044 7.29261 6.07412 7.18557 6.17394 7.08715C6.26337 6.99866 6.37306 6.85652 6.47269 6.74123C6.57194 6.62588 6.60506 6.54359 6.67144 6.41187C6.73787 6.28002 6.70462 6.16467 6.65494 6.06588C6.60506 5.96709 6.21825 4.99028 6.04125 4.59977Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="paint0_linear_8576_141444"
                            x1="772.572"
                            y1="1539.78"
                            x2="772.572"
                            y2="0.273438"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#1FAF38" />
                            <stop offset="1" stop-color="#60D669" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_8576_141444"
                            x1="800"
                            y1="1594.71"
                            x2="800"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#F9F9F9" />
                            <stop offset="1" stop-color="white" />
                          </linearGradient>
                          <clipPath id="clip0_8576_141444">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </p>
                  </label>
                  <label className="flex items-center gap-2" htmlFor="email">
                    <input
                      checked={watch("share_email")}
                      onChange={(e) => {
                        setValue("share_email", e.target.checked);
                      }}
                      type="checkbox"
                      name="email"
                      id="email"
                      disabled={!options?.length && !watch("email")}
                      className="rounded-[4px] disabled:cursor-not-allowed disabled:opacity-40 peer"
                    />
                    <p className="flex peer-disabled:opacity-40 peer-disabled:cursor-not-allowed justify-between w-full items-center">
                      Email
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.25 0H3.75C1.67893 0 0 1.67893 0 3.75V12.25C0 14.3211 1.67893 16 3.75 16H12.25C14.3211 16 16 14.3211 16 12.25V3.75C16 1.67893 14.3211 0 12.25 0Z"
                          fill="#F4F2ED"
                        />
                        <path
                          d="M2.60225 12.6907H4.59088V7.86109L1.75 5.73047V11.8384C1.75 12.31 2.13213 12.6907 2.60225 12.6907Z"
                          fill="#4285F4"
                        />
                        <path
                          d="M11.4062 12.6907H13.3949C13.8665 12.6907 14.2472 12.3086 14.2472 11.8385V5.73047L11.4062 7.86116"
                          fill="#34A853"
                        />
                        <path
                          d="M11.4062 4.16333V7.85652L14.2472 5.72589V4.58939C14.2472 3.53545 13.0441 2.93458 12.2017 3.5667"
                          fill="#FBBC04"
                        />
                        <path
                          d="M4.59375 7.86122V4.16809L8.00281 6.72478L11.4119 4.16797V7.86116L8.00281 10.418"
                          fill="#EA4335"
                        />
                        <path
                          d="M1.75 4.5972V5.73358L4.59088 7.86427V4.17114L3.79544 3.57452C2.95169 2.94239 1.75 3.54327 1.75 4.5972Z"
                          fill="#C5221F"
                        />
                      </svg>
                    </p>
                  </label>
                </div>
              </div>
            )}
            {selectedNumber && buttonType === "download" && (
              <div className="flex flex-col gap-3 w-full">
                <div className="bg-[#F9F9F9] rounded-xl p-2 flex flex-col gap-6 w-full">
                  <div className="flex flex-col gap-3 text-sm font-medium">
                    <div className="flex items-center gap-2.5">
                      <img
                        src="/images/createorder/profileIcon.svg"
                        alt="Remitter Name"
                        className="w-5 h-5"
                      />
                      <small className="text-gray-900 text-[14px] font-medium">
                        {selectedContact?.contactName}
                      </small>
                    </div>
                    <div className="flex text-sm font-medium flex-col gap-3">
                      <div className="flex items-center gap-2.5">
                        <img
                          src="/images/createorder/call.svg"
                          alt="Phone"
                          className="w-5 h-5"
                        />
                        <small className="text-gray-900 text-[14px] font-medium">
                          {selectedContact?.contactPhone !== ""
                            ? selectedContact?.contactPhone
                            : "NA"}
                        </small>
                      </div>
                      <div className="flex items-center gap-2.5">
                        <img
                          src="/images/createorder/sms.svg"
                          alt="Email"
                          className="w-5 h-5"
                        />
                        <small className="text-gray-900 text-[14px] font-medium">
                          {selectedContact?.email === ""
                            ? "NA"
                            : selectedContact?.email}
                        </small>
                      </div>
                    </div>
                    <div className="flex items-center gap-2.5">
                      <img
                        src="/images/createorder/location.svg"
                        alt="Address"
                        className="w-5 h-5"
                      />
                      <small className="max-w-xs text-gray-900 text-[14px] font-medium">
                        {selectedContact?.location !== ""
                          ? selectedContact?.location
                          : "NA"}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!options?.length &&
              inputValue.length >= 10 &&
              buttonType !== "share" && (
                <>
                  <div className="relative space-y-2">
                    <label
                      htmlFor="amount"
                      className="text-sm font-medium leading-[17px] text-[#666666]"
                    >
                      Name
                    </label>
                    <Input
                      type="text"
                      id="name"
                      name="name"
                      value={watch("name")}
                      onChange={(e) => {
                        const value = e.target.value;
                        setValue("name", value);
                      }}
                      placeholder="Enter name"
                      className="m-0 h-12 w-full border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
                    />
                  </div>
                  <div className="relative space-y-2">
                    <label
                      htmlFor="amount"
                      className="text-sm font-medium leading-[17px] text-[#666666]"
                    >
                      Email
                    </label>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      value={watch("email")}
                      onChange={(e) => {
                        const value = e.target.value;
                        setValue("email", value);
                      }}
                      placeholder="Enter email"
                      className="m-0 h-12 w-full border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
                    />
                  </div>
                </>
              )}
          </form>
          <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
            {buttonType === "download" ? (
              <>
                <button
                  className="disabled:opacity-40 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                  onClick={() => {
                    handleSubmit("download");
                  }}
                  disabled={!contactDetails?.value && !watch("name")}
                >
                  Download
                </button>
                <button
                  onClick={() => {
                    setButtonType("share");
                  }}
                  disabled={
                    !contactDetails?.value && !watch("name") && !watch("email")
                  }
                  className="rounded-lg disabled:opacity-40 border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                >
                  Share Quote
                </button>
              </>
            ) : (
              <div className="flex items-center justify-between w-full">
                <button
                  onClick={() => {
                    setButtonType("download");
                  }}
                  className="py-[11px] px-4 text-blue-700"
                >
                  Previous
                </button>
                <button
                  onClick={() => {
                    handleSubmit("share");
                  }}
                  disabled={!watch("share_whatsapp") && !watch("share_email")}
                  className="rounded-lg disabled:opacity-40 disabled:cursor-not-allowed border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                >
                  Share
                </button>
              </div>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialog>
  );
};
